import { get, isMockMode, simulateDelay } from "../api";

export const validateInvitation = ({ invitationId }) => {
	if (isMockMode()) {
		const testData = { isValid: true };

		return simulateDelay(50, () => testData);
	}

	return get(
		`Subscriptions/ValidateInvitation?invitationId=${invitationId}`,
		{ handleErrorManually: true }
	);
};
